export default __webpack_public_path__ + "static/media/alumini (2).698f58ea.jpg";